const semanticClassNames = {
  root: 'ratings-display',
  label: 'ratings-display__label',
} as const;

export default semanticClassNames;
